import { Component, OnInit } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';

@Component({
  selector: 'spinner-accessibility',
  templateUrl: './spinner-accessibility.component.html',
  styleUrls: ['./spinner-accessibility.component.sass']
})
export class SpinnerAccessibilityComponent implements OnInit {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;
  constructor(private templateService: TemplateUpdateService) { }

  ngOnInit(): void {
  }

}
